// @flow
import { useState, useCallback, useEffect } from 'react';

import { api } from 'app/api';
import { GET_REPORTS_DATA_FINANCES_CAFETERIA_CASH } from 'app/common/api/requests/reports/data';
import { convertResult } from 'app/common/api/requests/reports/data.finances_cafeteria_cash';

import type {
  CashBoxResult,
  Summary,
  Multiple,
  Payment,
} from 'app/dataTypes/reports/finances/CashBox.types';


export type {
  Summary,
  Multiple,
  Payment,
};

export type ReportData = CashBoxResult | null

export default function useReportData(reportId: ?number): [ReportData, boolean] {
  const [reportData, setReportData] = useState < ReportData > (null);
  const [loading, setLoading] = useState(false);

  const requestItems = useCallback(async () => {
    if (!reportId) return;

    setLoading(true);
    const res = await api.request(GET_REPORTS_DATA_FINANCES_CAFETERIA_CASH, {
      error: 'Не удалось загрузить данные отчета',
      params: {
        report_id: reportId,
      },
      convertions: {
        convertResult,
      },
    });

    if (res) {
      setReportData(res);
    }
    setLoading(false);
  }, [reportId]);


  useEffect(() => {
    requestItems();
  }, [requestItems]);

  return [reportData, loading];
}
